import { datadogRum } from "@datadog/browser-rum"
import { App } from "antd"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router"
import { useLocation, useNavigate } from "react-router-dom"

import { RoutesPaths } from "../constants/user-routes"
import { logoutThunk } from "../Containers/LoginPage/redux/auth.thunks"
import { changeNextCreateAccountStep, userSetProp } from "../Containers/User/redux/user.actions"
import { deleteBusinessAccount } from "../Containers/User/redux/user.thunks"
import Icon from "../Icon"
import Images from "../Images"
import { modalConfig } from "../theme"
import { defaultInnerPage } from "../Utils/appRoutes"
import ButtonComponent from "./Button"
import IconWithText from "./Text"

const LoginHeader = ({ withLogout, children }) => {
  const { modal } = App.useApp()
  const { isMobile, theme } = useSelector((state) => state.nav)
  const businessAccountFetching = useSelector((state) => state.user.businessAccountFetching)
  const businessAccount = useSelector((state) => state.user.businessAccount)
  const nextCreateAccountStep = useSelector((state) => state.user.nextCreateAccountStep)
  const redirectAfterCreateAccount = useSelector((state) => state.user.redirectAfterCreateAccount)

  // This check doesn't work. Backend returns completed_steps in POST endpoint, but not in GET. In most cases this field is empty
  // const fullyCompletedBa = (businessAccount?.["completed_steps"] === "5/5" || businessAccount?.["completed_steps"] === "4/4")

  const { enrollmentId } = useParams()
  let { pathname, search } = useLocation()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleCancelCreateAccount = () => {
    modal.confirm({
      ...modalConfig("exclamation"),
      centered: !isMobile,

      title: t("Are you sure you want to exit?"),
      content: t("Any changes you have made will not be saved."),

      cancelText: t("Stay"),
      okText: t("Exit"),
      onOk() {
        if (enrollmentId) {
          let enrollmentPage = pathname.split("/").slice(0, -2).join("/")
          dispatch(userSetProp({ key: "nextManageEnrollmentStep", value: null }))
          navigate(`${enrollmentPage}${search}`, { replace: true })
        } else {
          if (businessAccount?.id && nextCreateAccountStep !== 1) {
            dispatch(deleteBusinessAccount(businessAccount?.id))
          } else {
            dispatch(changeNextCreateAccountStep(null))
            navigate(redirectAfterCreateAccount || defaultInnerPage, { replace: true })
            dispatch(userSetProp({ key: "redirectAfterCreateAccount", value: null }))
          }
        }
      }
    })
  }

  const handleLogout = () => {
    datadogRum?.clearUser()
    dispatch(logoutThunk())
  }

  return (
    <div className="header-row" style={{ position: "relative" }}>
      <img src={Images?.[theme === "dark" ? "logoWithTextWhite" : "logoWithText"]} alt="" />
      {children}

      {withLogout && (
        <div
          style={{
            position: "absolute",
            right: "7.77vw",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer"
          }}
        >
          <IconWithText
            text={t("Log out")}
            icon={() => <Icon type="logout" role="icon" />}
            onClick={handleLogout}
          />
        </div>
      )}

      {(nextCreateAccountStep || enrollmentId) && (
        <ButtonComponent
          size="large"
          icon={<Icon type={"close_modal"} />}
          style={{ position: "absolute", right: 32 }}
          loading={businessAccountFetching}
          onClick={handleCancelCreateAccount}
          className="flex center"
        />
      )}

      {pathname.includes(RoutesPaths.prevent.premium_features) && (
        <ButtonComponent
          size="large"
          icon={<Icon type={"close_modal"} />}
          style={{ position: "absolute", right: 32 }}
          onClick={() => navigate(RoutesPaths.configure.processors, { replace: true })}
          className="flex center"
        />
      )}
    </div>
  )
}

LoginHeader.defaultProps = {
  withLogout: false
}

export default LoginHeader
